var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4, _path5, _rect11, _path6, _path7, _rect12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmkCelt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 96,
    viewBox: "0 0 136 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56.3999,
    y: 22.8611,
    width: 58.6667,
    height: 60.1744,
    fill: "#EDF7FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4,
    y: 8.15088,
    width: 61.3333,
    height: 82.907,
    rx: 4,
    fill: "#398CB0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3998,
    y: 12.1631,
    width: 53.3333,
    height: 74.8837,
    rx: 3,
    fill: "#F1F4FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.7332 75.0112V86.0461C77.7332 86.5984 77.2854 87.0461 76.7332 87.0461H64.3998L77.7332 75.0112Z",
    fill: "#ECECEC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 23.3621,
    width: 15,
    height: 15.0436,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4,
    y: 27.875,
    width: 22.5,
    height: 3.00872,
    fill: "#5D9ED1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    y: 47.4316,
    width: 31.5,
    height: 3.00871,
    fill: "#B6D6EF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    y: 65.4841,
    width: 27,
    height: 3.00872,
    fill: "#B6D6EF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4,
    y: 33.8926,
    width: 16.5,
    height: 3.00873,
    fill: "#5D9ED1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    y: 56.4578,
    width: 22.5,
    height: 3.00872,
    fill: "#B6D6EF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    y: 74.5103,
    width: 19.5,
    height: 3.00872,
    fill: "#B6D6EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1499 48.936L31.6499 50.4404L34.6499 47.4316",
    stroke: "#FF9690"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1499 57.9621L31.6499 59.4665L34.6499 56.4578",
    stroke: "#FF9690"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1499 66.9885L31.6499 68.4928L34.6499 65.4841",
    stroke: "#FF9690"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1499 74.5102L31.6499 76.0146L34.6499 73.0059",
    stroke: "#FF9690"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 94.0002,
    y: 33.8921,
    width: 5.99999,
    height: 49.6439,
    fill: "#FF9690"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0001 27.3706C94.0001 26.8183 94.4478 26.3706 95.0001 26.3706H99.0001C99.5524 26.3706 100 26.8183 100 27.3706V32.388H94.0001V27.3706Z",
    fill: "#B6D6EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0002 83.5361H100L97.0002 91.0579L94.0002 83.5361Z",
    fill: "#F2D0B2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36.4,
    y: 6.81396,
    width: 29.3333,
    height: 12.0349,
    fill: "#5D9ED1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmkCelt);
export default __webpack_public_path__ + "static/media/mmk_celt.2ad84d80547cb6ec0f9ccbb8822d12fd.svg";
export { ForwardRef as ReactComponent };